import React from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  Badge,
  UncontrolledTooltip,
} from 'reactstrap';

const STATUS_STYLE = {
  delivered: { bg: '#10b981', label: 'Entregue' },
  pending: { bg: '#f59e0b', label: 'Aguardando retry' },
  in_flight: { bg: '#6b7280', label: 'Em processamento' },
  retried: { bg: '#6366f1', label: 'Sobrescrita por retry' },
  failed_permanently: { bg: '#ef4444', label: 'Falhou definitivamente' },
};

const ENV_LABEL = {
  test: { label: 'TESTE', color: '#6b7280' },
  live: { label: 'PROD', color: '#2544b1' },
};

const httpColor = code => {
  if (!code) return '#9ca3af';
  if (code >= 200 && code < 300) return '#10b981';
  if (code >= 300 && code < 400) return '#3b82f6';
  if (code >= 400 && code < 500) return '#f59e0b';
  return '#ef4444';
};

export default function WebhookDispatchCard({ dispatch, onOpenDetail }) {
  const status = STATUS_STYLE[dispatch.status] || STATUS_STYLE.in_flight;
  const env =
    ENV_LABEL[dispatch?.partner_application?.environment] || ENV_LABEL.test;

  return (
    <Card
      style={{
        boxShadow: '0rem 0.275rem 0.3rem 0.1rem rgba(0, 0, 0, 0.035)',
        cursor: 'pointer',
      }}
      className="card new-layout list-card grow-on-hover overflow-hidden"
      onClick={() => onOpenDetail(dispatch)}
    >
      <CardBody className="card-body new-layout px-3 py-3">
        {/* desktop */}
        <Row className="w-100 h-100 mx-0 d-none d-lg-flex align-items-center">
          <Col xs={3} align="start">
            <div
              className="new-layout-card-list-strong-value text-truncate"
              style={{
                fontFamily:
                  '"JetBrains Mono", Menlo, Monaco, Consolas, monospace',
                fontSize: '13px',
              }}
            >
              {dispatch.event_type}
            </div>
            {dispatch.event_id && (
              <div
                className="text-muted text-truncate"
                style={{
                  fontFamily: '"JetBrains Mono", Menlo, monospace',
                  fontSize: '10px',
                }}
                id={`event-id-${dispatch.id}`}
              >
                {dispatch.event_id}
              </div>
            )}
          </Col>

          <Col xs={3} align="start">
            <div className="new-layout-table-column-value text-truncate">
              {dispatch?.partner_application?.name || (
                <span className="text-muted">—</span>
              )}
              {dispatch?.partner_application && (
                <Badge
                  className="ml-2"
                  style={{
                    backgroundColor: env.color,
                    color: '#fff',
                    fontSize: '9px',
                    padding: '1px 5px',
                  }}
                >
                  {env.label}
                </Badge>
              )}
            </div>
            <div
              className="text-truncate"
              id={`webhook-url-${dispatch.id}`}
              style={{
                fontFamily: '"JetBrains Mono", Menlo, monospace',
                fontSize: '11px',
                color: '#6b7280',
              }}
            >
              {dispatch.webhook_url || '—'}
            </div>
            {dispatch.webhook_url && (
              <UncontrolledTooltip target={`webhook-url-${dispatch.id}`}>
                {dispatch.webhook_url}
              </UncontrolledTooltip>
            )}
          </Col>

          <Col xs={2} align="start">
            <Badge
              style={{
                backgroundColor: status.bg,
                color: '#fff',
                fontSize: '10px',
                padding: '4px 8px',
              }}
            >
              {status.label}
            </Badge>
            {dispatch.formatted_next_retry_at && (
              <div
                className="text-muted"
                style={{ fontSize: '10px', marginTop: 2 }}
              >
                Retry: {dispatch.formatted_next_retry_at}
              </div>
            )}
          </Col>

          <Col xs={1} align="start">
            {dispatch.response_status ? (
              <span
                style={{
                  fontFamily: '"JetBrains Mono", Menlo, monospace',
                  fontWeight: 600,
                  color: httpColor(dispatch.response_status),
                }}
              >
                {dispatch.response_status}
              </span>
            ) : (
              <span className="text-muted">—</span>
            )}
          </Col>

          <Col xs={1} align="start">
            <div className="new-layout-table-column-value">
              {dispatch.attempt_count || 0}
            </div>
          </Col>

          <Col xs={2} align="start">
            <div
              className="new-layout-table-column-value"
              style={{ fontSize: '12px' }}
            >
              {dispatch.formatted_created_at}
            </div>
          </Col>
        </Row>

        {/* mobile */}
        <Row className="w-100 h-100 mx-0 d-lg-none">
          <Col className="px-0">
            <Row className="w-100 mx-0">
              <Col xs={9} align="start" className="px-0">
                <div
                  className="new-layout-card-mobile font-weight-600"
                  style={{
                    fontFamily: '"JetBrains Mono", Menlo, monospace',
                    fontSize: '13px',
                  }}
                >
                  {dispatch.event_type}
                </div>
              </Col>
              <Col xs={3} className="px-0 d-flex justify-content-end">
                <Badge
                  style={{
                    backgroundColor: status.bg,
                    color: '#fff',
                    fontSize: '10px',
                    padding: '3px 7px',
                  }}
                >
                  {status.label}
                </Badge>
              </Col>
            </Row>
            <hr />
            <Row className="w-100 mx-0">
              <Col className="px-0">
                <div className="d-flex flex-row align-items-baseline">
                  <div className="new-layout-card-mobile label font-weight-500 d-inline">
                    Aplicação:
                  </div>
                  <div className="new-layout-card-mobile value d-inline ml-2 text-truncate">
                    {dispatch?.partner_application?.name || '—'}
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="w-100 mx-0">
              <Col className="px-0">
                <div className="d-flex flex-row align-items-baseline">
                  <div className="new-layout-card-mobile label font-weight-500 d-inline">
                    URL:
                  </div>
                  <div
                    className="new-layout-card-mobile value d-inline ml-2 text-truncate"
                    style={{
                      fontFamily: '"JetBrains Mono", Menlo, monospace',
                      fontSize: '11px',
                    }}
                  >
                    {dispatch.webhook_url}
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="w-100 mx-0">
              <Col className="px-0">
                <div className="d-flex flex-row align-items-baseline">
                  <div className="new-layout-card-mobile label font-weight-500 d-inline">
                    HTTP:
                  </div>
                  <div
                    className="new-layout-card-mobile value d-inline ml-2"
                    style={{
                      fontFamily: '"JetBrains Mono", Menlo, monospace',
                      fontWeight: 600,
                      color: httpColor(dispatch.response_status),
                    }}
                  >
                    {dispatch.response_status || '—'}
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="w-100 mx-0">
              <Col className="px-0">
                <div className="d-flex flex-row align-items-baseline">
                  <div className="new-layout-card-mobile label font-weight-500 d-inline">
                    Tentativas:
                  </div>
                  <div className="new-layout-card-mobile value d-inline ml-2">
                    {dispatch.attempt_count || 0}
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="w-100 mx-0">
              <Col className="px-0">
                <div className="d-flex flex-row align-items-baseline">
                  <div className="new-layout-card-mobile label font-weight-500 d-inline">
                    Criado:
                  </div>
                  <div className="new-layout-card-mobile value d-inline ml-2">
                    {dispatch.formatted_created_at}
                  </div>
                </div>
              </Col>
            </Row>
            <div
              className="text-center mt-2 text-muted"
              style={{ fontSize: 11 }}
            >
              Toque para ver detalhes
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}
